export default "__VITE_ASSET__BFvHBdF4__"